// Author thq
// Date 2021-11-25 14:42:05

class EmSppSparePartsSpa {
constructor({
        id = null,
        code = '',
        name = '',
        spaIdSpc = '',
        spaUnit = '',
        spaModel = '',
        spaSpec = '',
        spaTexture = '',
        spaFunctionDesc = '',
        spaRemark = '',
        spaAttachment = '',
        spaAttachmentList = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.spaIdSpc = spaIdSpc;
    this.spaUnit = spaUnit;
    this.spaModel = spaModel;
    this.spaSpec = spaSpec;
    this.spaTexture = spaTexture;
    this.spaFunctionDesc = spaFunctionDesc;
    this.spaRemark = spaRemark;
    this.spaAttachment = spaAttachment;
    this.spaAttachmentList = spaAttachmentList;
}
}

function newEntity() {
return new EmSppSparePartsSpa();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spaNameSpc',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaNameSpc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spaUnit',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spaVersion',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaVersion',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spaModel',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaModel',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spaSpec',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaSpec',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
            key: 'spaSpec',
            label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaSpec',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
        key: 'spaFunctionDesc',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaFunctionDesc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spaRemark',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'spaAttachmentList',
        label: 'label.em.spareparts.emSppSparePartsSpa.grid.spaAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    nameFilter : '',
    spaIdSpcFilter : '',
    spaModelFilter : '',
    spaSpecFilter : '',
    spaTextureFilter : '',
    spaFunctionDescFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.em.spareparts.emSppSparePartsSpa.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppSparePartsSpa.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaIdSpcFilter',
        label: 'label.em.spareparts.emSppSparePartsSpa.filter.spaIdSpc',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emSppSparePartsCatSpc'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'spaModelFilter',
        label: 'label.em.spareparts.emSppSparePartsSpa.filter.spaModel',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaSpecFilter',
        label: 'label.em.spareparts.emSppSparePartsSpa.filter.spaSpec',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaTextureFilter',
        label: 'label.em.spareparts.emSppSparePartsSpa.filter.spaTexture',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaFunctionDescFilter',
        label: 'label.em.spareparts.emSppSparePartsSpa.filter.spaFunctionDesc',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'spaIdSpc',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.spaIdSpc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,required: true
            ,entity: 'emSppSparePartsCatSpc'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'spaUnit',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.spaUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaModel',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.spaModel',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaSpec',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.spaSpec',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaTexture',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.spaTexture',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaFunctionDesc',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.spaFunctionDesc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spaRemark',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.spaRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'spaAttachmentList',
        label: 'label.em.spareparts.emSppSparePartsSpa.entity.spaAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'spaAttachment'
                }
        }
]

export {EmSppSparePartsSpa, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
